import { objectExtensions } from '@felicity/primitives';
import { domExtensions } from '@felicity/vision';
import { registerLicense } from '@syncfusion/ej2-base';
import { AppBar, Sidebar } from '@syncfusion/ej2-navigations';
import { Button } from '@syncfusion/ej2-buttons';
import { MetadataProvider } from '@felicity/data-modelling';
import {
  fixEditSuccess
} from '@felicity/data-management';
import {
  AssessmentList,
  AssessmentForm, CriterionPane,
  ScoreChart, HazardRiskChart, HazardWeightChart, Report
} from '@felicity/multi-criteria-analysis';
import mapboxgl from 'mapbox-gl';

import config from './config.json';

import Users from './screens/Users.mjs';
import UnitsOfMeasure from './screens/UnitsOfMeasure.mjs';
import Indicators from './screens/Indicators.mjs';
import GenericFrameworks from './screens/GenericFrameworks.mjs';
import AssessmentTools from './screens/AssessmentTools.mjs';
import Assessments from './screens/Assessments.mjs';
import Projects from './screens/Projects.mjs';
import PresentationViewer from './ui/PresentationViewer.mjs';

import './global.mjs';
import './subscribe.mjs';
import './app.scss';

registerLicense(config.syncfusion.licenseKey);
fixEditSuccess();
mapboxgl.accessToken = config.mapboxgl.accessToken;

window.document.ready(() => {
  const $sidebar = document.getElementById('sidebar'),
    sidebar = $sidebar
      ? new Sidebar({
        width: '220px',
        dockSize: '60px',
        target: 'main',
        enableDock: false,
        type: 'Auto',
        animate: true,
        enableGestures: false
      }) : null;
  sidebar?.appendTo('#sidebar');

  const $appbar = document.getElementById('appbar'),
    appbar = $appbar
      ? new AppBar({
        colorMode: 'Light',
        position: 'Top',
        showMenuIcon: true,
        menuIconClick: () => {
          sidebar.toggle();
        }
      }) : null;
  appbar?.appendTo($appbar);

  const $toggleButton = $appbar?.querySelector('button[data-action="toggleSidebar"]'),
    toggleButton = $toggleButton
      ? new Button({
        cssClass: 'e-inherit menu', iconCss: 'e-icons e-menu',
      }) : null;
  toggleButton?.appendTo($toggleButton);

  $toggleButton?.addEventListener('click', () => {
    sidebar.toggle();
  });

  const schema = document.querySelector('script[name="schema-definition"][type="application/json"]')?.innerHTML;
  if (schema) {
    MetadataProvider.loadJSON({ components: JSON.parse(schema) })
      .then(() => {
        AssessmentList.register('assessment-list');
        Users.register('users');
        UnitsOfMeasure.register('units-of-measure');
        Indicators.register('indicators');
        GenericFrameworks.register('generic-frameworks');
        AssessmentTools.register('assessment-tools');
        Assessments.register('assessments');
        Projects.register('projects');
      });
  } else {
    ScoreChart.register('score-chart');
    HazardRiskChart.register('hazard-risk-chart');
    HazardWeightChart.register('hazard-weight-chart');
    Report.register('report');

    CriterionPane.register('criterion-pane');
    AssessmentForm.register('assessment-form');

    PresentationViewer.register('presentation-viewer');
  }
});
